export const Theme = {
  colors: {
    mainFontColor: "#ffffff",
    secondaryFontColor: "rgba(255,255,255,0.62)",

    accentColor: "#6ad9ff",
    noAccentColor: "#c0c0c0",

    borderColor: "#343434",
    blockColor: "#0d0d0d",
    pageBgColor: "#080808",

    dangerColor: "#ff6b6b",
    dangerSoftColor: "rgba(255, 107, 107, 0.10)",
    dangerBorderColor: "rgba(255, 107, 107, 0.18)",

    warningColor: "#ffb84d",
    warningSoftColor: "rgba(255, 184, 77, 0.10)",
    warningBorderColor: "rgba(255, 184, 77, 0.18)",

    successColor: "#39d98a",
    successSoftColor: "rgba(57, 217, 138, 0.10)",
    successBorderColor: "rgba(57, 217, 138, 0.18)",
  },

  font: {
    fontSize1: "18px",
    fontSize2: "16px",
    fontSize3: "14px",
    fontSize4: "12px",
    fontSize5: "22px",

    fontWeight1: 700,
    fontWeight2: 600,
    fontWeight3: 500,
    fontWeight4: 400,
  },

  spacing: {
    pageX: "15px",
    pageBottom: "18px",

    card: "14px",
    cardCompact: "12px",

    sectionGap: "16px",
    blockGap: "14px",
    itemGap: "10px",
    rowGap: "8px",

    radiusLg: "20px",
    radiusMd: "16px",
    radiusSm: "14px",
    radiusXs: "12px",
  },

  media: {
    maxWidth: "768px",
  },
};